import { render, staticRenderFns } from "./CadasterDialog.vue?vue&type=template&id=5189112a"
import script from "./CadasterDialog.vue?vue&type=script&lang=js"
export * from "./CadasterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports